import React from 'react';
import TailwindApp from '../assets/first-page.png';
import NotesApp from '../assets/notes-app.png';
import TravelPage from '../assets/travel.png';
import Dashboard from '../assets/dashboard.png';
import BrandPage from '../assets/brand-page.png';

const Work = () => {
	return (
		<div name='work' className='pt-10 work w-full md:h-screen text-gray-300 bg-[#0a192f]'>
				<div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-screen'>
						<div className='pb-8'>
								<p className='text-4xl font-bold inline border-b-4 text-gray-300 border-pink-600'>
										Works
								</p>
								<p className='py-6'>
										// Check out some of my recent works
								</p>
						</div >
						{/* Container */}
						<div className='grid sm:grid-cols-2 md:grid-cols-3 gap-4'>
								{/* Grid */}
								<div 
										style={{ backgroundImage: `url(${TailwindApp})` }}
										className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'>
										{/* Hover Effects */}
										<div className='opacity-0 group-hover:opacity-100'>
												<span className='text-2xl font-bold text-white tracking-wider'>
														Tailwind Page
												</span>
												<div className='pt-8 text-center'>
														<a href="https://prykhodchenkomykyta.github.io/tailwind/">
																<button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
																		Demo
																</button>
														</a>
														<a href="https://github.com/prykhodchenkomykyta/tailwind">
																<button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
																		Code
																</button>
														</a>
												</div>
										</div>
								</div>
								<div 
										style={{ backgroundImage: `url(${Dashboard})` }}
										className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'>
										{/* Hover Effects */}
										<div className='opacity-0 group-hover:opacity-100'>
												<span className='text-2xl font-bold text-white tracking-wider'>
														Dashboard
												</span>
												<div className='pt-8 text-center'>
														<a href="https://prykhodchenkomykyta.github.io/dashboard/">
																<button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
																		Demo
																</button>
														</a>
														<a href="https://github.com/prykhodchenkomykyta/dashboard">
																<button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
																		Code
																</button>
														</a>
												</div>
										</div>
								</div>
								<div 
										style={{ backgroundImage: `url(${BrandPage})` }}
										className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'>
										{/* Hover Effects */}
										<div className='opacity-0 group-hover:opacity-100'>
												<span className='text-2xl font-bold text-white tracking-wider'>
														React Page
												</span>
												<div className='pt-8 text-center'>
														<a href="https://prykhodchenkomykyta.github.io/react-page/">
																<button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
																		Demo
																</button>
														</a>
														<a href="https://github.com/prykhodchenkomykyta/react-page">
																<button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
																		Code
																</button>
														</a>
												</div>
										</div>
								</div>
						    	<div 
										style={{ backgroundImage: `url(${NotesApp})` }}
										className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'>
										{/* Hover Effects */}
										<div className='opacity-0 group-hover:opacity-100'>
												<span className='text-2xl font-bold text-white tracking-wider'>
														ReactJS Notes Page
												</span>
												<div className='pt-8 text-center'>
														<a href="https://prykhodchenkomykyta.github.io/react-notes/">
																<button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
																		Demo
																</button>
														</a>
														<a href="https://github.com/prykhodchenkomykyta/react-notes">
																<button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
																		Code
																</button>
														</a>
												</div>
										</div>
								</div>
						      <div 
										style={{ backgroundImage: `url(${TravelPage})` }}
										className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'>
										{/* Hover Effects */}
										<div className='opacity-0 group-hover:opacity-100'>
												<span className='text-2xl font-bold text-white tracking-wider'>
														Tailwind Page
												</span>
												<div className='pt-8 text-center'>
														<a href="https://prykhodchenkomykyta.github.io/react-travel-page/">
																<button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
																		Demo
																</button>
														</a>
														<a href="https://github.com/prykhodchenkomykyta/react-travel-page">
																<button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
																		Code
																</button>
														</a>
												</div>
												<span name='contact'></span>
										</div>
								</div>
						</div>
				</div>
		</div>
 );
};

export default Work;